import React from "react";
import { View } from "react-native";
import { AppText } from "@toothfairy/shared-ui";

// One-line descriptions for ToothFairyAI built-in agent tools (from product docs).
// Used as a fallback when a tool/hook has no user-written description.
export const BUILTIN_TOOL_DESCRIPTIONS = {
  deep_internet_search: "Exhaustive web research with multiple queries and source synthesis.",
  internet_search: "Search the web for current information.",
  conversation_retrieval: "Recall and reference previous conversation context.",
  image_generation: "Generate original images based on a description.",
  image_adaptation: "Edit and modify existing images using image inputs.",
  code_interpreter: "Execute programming scripts, analyse data, manipulate files.",
  video_generation: "Create custom video content.",
  "3d_model_generation": "Design and create three-dimensional models.",
  long_term_memory: "Store and recall persistent user instructions.",
  images_retrieval: "Fetch existing images from available data sources.",
  rag: "Quick vector search for fast, targeted retrieval.",
  deep_rag: "Full knowledge hub scan for comprehensive data crunching.",
  deep_thinking: "Enhanced reasoning and complex problem-solving.",
  reasoning: "Structured logical reasoning for problem-solving.",
  deep_reasoning: "Extended reasoning chains for multi-step analysis.",
  analyze: "Dedicated file analysis for documents, spreadsheets and uploads.",
  email: "Send email messages to users.",
  whatsapp: "Send WhatsApp messages to users.",
  sms: "Send SMS text messages to users.",
  canvas: "Co-edit documents with AI using atomic transformations.",
  browser: "Interact with web applications as a human user.",
  scheduling: "Schedule future tasks and autonomous agent workflows.",
  ask_user_question: "Pause and ask clarifying questions when facing ambiguity.",
  update_plan: "Dynamically refine the execution strategy as new info emerges.",
};

const truncate = (s, n = 150) =>
  s && s.length > n ? s.slice(0, n).trimEnd() + "…" : s;

export const getToolOptionDescription = (option) =>
  option?.description || BUILTIN_TOOL_DESCRIPTIONS[option?.name] || "";

export const getHookOptionDescription = (option) => option?.description || "";

// Returns a react-select formatOptionLabel that renders the option name in bold
// with its description in grey below it (dropdown rows only; chips keep the plain label).
export const makeOptionLabelWithDescription =
  (currentTheme, getDescription) => (option, meta) => {
    if (meta?.context === "value") return option?.label;
    const desc = truncate(getDescription(option));
    return (
      <View style={{ flexDirection: "column" }}>
        <AppText
          style={{
            fontWeight: "600",
            color: currentTheme?.theme?.font_color,
            fontSize: currentTheme?.theme?.small_font_size,
          }}
        >
          {option?.label}
        </AppText>
        {desc ? (
          <AppText
            style={{
              color: currentTheme?.theme?.mediumGrey,
              fontSize: currentTheme?.theme?.extra_small_font_size || 12,
              marginTop: 1,
            }}
          >
            {desc}
          </AppText>
        ) : null}
      </View>
    );
  };
